import { render } from "./MarqueeBand.vue?vue&type=template&id=3269708a&scoped=true"
import script from "./MarqueeBand.vue?vue&type=script&lang=js"
export * from "./MarqueeBand.vue?vue&type=script&lang=js"

import "./MarqueeBand.vue?vue&type=style&index=0&id=3269708a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3269708a"]])

export default __exports__